// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui from "../../shared/Ui.re.mjs";
import * as React from "react";
import * as HomeAtoms from "../../atoms/home/HomeAtoms.re.mjs";
import * as HomeContent from "./HomeContent.re.mjs";
import * as LucideReact from "lucide-react";
import * as Core from "@linaria/core";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as FramerMotion from "framer-motion";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

function slides() {
  return [
    {
      src: "https://images.instapainting.com/58d4f8a787456fcc228b4597.jpg",
      medium: t`Oil on Canvas`,
      title: t`Oil Painting from Photo`,
      sku: "custphotoreal"
    },
    {
      src: "https://static3.instapainting.com/images/front/592ae69687456f55498b4679.jpg",
      medium: t`Oil on Canvas`,
      title: t`Oil Painting from Photo`,
      sku: "custphotoreal"
    },
    {
      src: "https://static3.instapainting.com/images/front/592bf4d287456f0c658b4588.jpg",
      medium: t`Watercolor on Paper`,
      title: t`Watercolor Painting from Photo`,
      sku: "custwatercolor"
    },
    {
      src: "https://static3.instapainting.com/images/front/592e25d887456f9f488b4582.jpg",
      medium: t`Oil on Canvas`,
      title: t`Oil Painting from Photo`,
      sku: "custphotoreal"
    },
    {
      src: "https://static3.instapainting.com/images/front/5928e5da87456f762c8b4575.jpg",
      medium: t`Oil on Canvas`,
      title: t`Oil Painting from Photo`,
      sku: "custphotoreal"
    },
    {
      src: "https://static3.instapainting.com/images/front/59302b5e87456f0b228b4573.jpg",
      medium: t`Watercolor on Paper`,
      title: t`Watercolor Painting from Photo`,
      sku: "custwatercolor"
    }
  ];
}

function ShowcaseCarousel(props) {
  let slides$1 = slides();
  let total = slides$1.length;
  let match = React.useState(() => 0);
  let setIndex = match[1];
  let index = match[0];
  let match$1 = React.useState(() => false);
  let setPaused = match$1[1];
  let paused = match$1[0];
  let next = () => setIndex(i => Primitive_int.mod_(i + 1 | 0, total));
  let prev = () => setIndex(i => Primitive_int.mod_((i - 1 | 0) + total | 0, total));
  React.useEffect(() => {
    if (paused) {
      return;
    }
    let id = setInterval(() => setIndex(i => Primitive_int.mod_(i + 1 | 0, total)), 6000);
    return () => {
      clearInterval(id);
    };
  }, [paused]);
  React.useEffect(() => {
    let nextSrc = slides$1[Primitive_int.mod_(index + 1 | 0, total)].src;
    let prevSrc = slides$1[Primitive_int.mod_((index - 1 | 0) + total | 0, total)].src;
    let preload = (function(src) { var img = new Image(); img.src = src; });
    preload(nextSrc);
    preload(prevSrc);
  }, [index]);
  let slide = slides$1[index];
  return JsxRuntime.jsxs("section", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(FramerMotion.AnimatePresence, {
            mode: "sync",
            children: JsxRuntime.jsx(FramerMotion.motion.div, {
              className: Core.cx("absolute inset-0"),
              animate: {
                opacity: 1.0,
                scale: 1.0
              },
              initial: {
                opacity: 0.0,
                scale: 1.03
              },
              exit: {
                opacity: 0.0
              },
              transition: {
                duration: 1.0,
                ease: "easeOut"
              },
              children: JsxRuntime.jsx(Ui.DImg.make, {
                src: slide.src,
                alt: slide.title,
                className: Core.cx("w-full h-full object-cover"),
                imgixParams: {
                  auto: "enhance,compress",
                  fit: "crop"
                },
                sizes: "100vw",
                width: 1600,
                height: 900,
                lazyLoad: index !== 0
              })
            }, slide.src)
          }),
          JsxRuntime.jsx("div", {
            className: Core.cx("absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-black/55 via-black/20 to-transparent pointer-events-none")
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(FramerMotion.AnimatePresence, {
              mode: "wait",
              children: JsxRuntime.jsx(FramerMotion.motion.p, {
                className: Core.cx("text-[10px] tracking-[0.3em] uppercase text-white/80 font-light"),
                animate: {
                  opacity: 1.0,
                  y: 0.0
                },
                initial: {
                  opacity: 0.0,
                  y: -4.0
                },
                exit: {
                  opacity: 0.0
                },
                transition: {
                  duration: 0.6,
                  ease: "easeOut"
                },
                children: slide.medium
              }, slide.medium)
            }),
            className: Core.cx("absolute top-8 md:top-10 left-0 right-0 flex justify-center px-6 pointer-events-none")
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(FramerMotion.AnimatePresence, {
                  mode: "wait",
                  children: JsxRuntime.jsx(FramerMotion.motion.h2, {
                    className: Core.cx("font-serif font-extralight text-white text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-2xl"),
                    animate: {
                      opacity: 1.0,
                      y: 0.0
                    },
                    initial: {
                      opacity: 0.0,
                      y: 12.0
                    },
                    exit: {
                      opacity: 0.0,
                      y: -6.0
                    },
                    transition: {
                      duration: 0.6,
                      ease: "easeOut"
                    },
                    children: slide.title
                  }, slide.title)
                }),
                JsxRuntime.jsx(HomeAtoms.ArrowLink.make, {
                  href: HomeContent.productLink(slide.sku),
                  label: t`Upload Photo & Place Order`,
                  tone: "light"
                })
              ],
              className: Core.cx("max-w-6xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-6")
            }),
            className: Core.cx("absolute inset-x-0 bottom-0 px-6 md:px-12 lg:px-16 pb-10 md:pb-14")
          }),
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx(LucideReact.ArrowLeft, {
              size: 16,
              strokeWidth: 1.5
            }),
            "aria-label": t`Previous slide`,
            className: Core.cx("absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center text-white/80 hover:text-white border border-white/20 hover:border-white/60 rounded-full backdrop-blur-sm bg-white/5 hover:bg-white/10 transition-all duration-300"),
            type: "button",
            onClick: param => prev()
          }),
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx(LucideReact.ArrowRight, {
              size: 16,
              strokeWidth: 1.5
            }),
            "aria-label": t`Next slide`,
            className: Core.cx("absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center text-white/80 hover:text-white border border-white/20 hover:border-white/60 rounded-full backdrop-blur-sm bg-white/5 hover:bg-white/10 transition-all duration-300"),
            type: "button",
            onClick: param => next()
          })
        ],
        className: Core.cx("relative w-full h-[60vh] md:h-[80vh] min-h-[480px] max-h-[820px] overflow-hidden bg-gray-900"),
        onMouseEnter: param => setPaused(param => true),
        onMouseLeave: param => setPaused(param => false)
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("p", {
              children: [
                HomeAtoms.pad(index + 1 | 0),
                JsxRuntime.jsx("span", {
                  children: "/",
                  className: Core.cx("text-gray-300 mx-2")
                }),
                HomeAtoms.pad(total)
              ],
              className: Core.cx("text-[10px] tracking-[0.3em] uppercase text-gray-500 font-light tabular-nums")
            }),
            JsxRuntime.jsx("div", {
              children: slides$1.map((s, i) => {
                let title = s.title;
                return JsxRuntime.jsx("button", {
                  children: JsxRuntime.jsx("span", {
                    className: Core.cx("block h-px transition-all duration-500", i === index ? "w-10 md:w-14 bg-gray-900" : "w-4 md:w-6 bg-gray-300 group-hover:bg-gray-500")
                  }),
                  "aria-label": t`Go to ${title}`,
                  className: Core.cx("group relative py-2"),
                  type: "button",
                  onClick: param => setIndex(param => i)
                }, s.src);
              }),
              className: Core.cx("flex items-center gap-3")
            })
          ],
          className: Core.cx("max-w-6xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between gap-6")
        }),
        className: Core.cx("border-t border-gray-200 bg-[#faf9f6]")
      })
    ],
    "aria-label": t`Sample paintings`,
    className: Core.cx("w-full bg-[#faf9f6]")
  });
}

let autoAdvanceMs = 6000;

let make = ShowcaseCarousel;

export {
  slides,
  autoAdvanceMs,
  make,
}
/*  Not a pure module */
